import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  subCategories: [],
};

const subCategorySlice = createSlice({
  name: "subCategories",
  initialState,
  reducers: {
    loadSubCategories: (state, action) => {
      state.subCategories = action.payload;
    },
  },
});

export const { loadSubCategories } = subCategorySlice.actions;

export const selectSubCategories = (state) => state.subCategories.subCategories;
export default subCategorySlice.reducer; 